export const SHOULD_SHOW_GROWTH_CHART = true
